import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html'
})
export class SpinnerComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {
    }
}
